export type DateRangePreset = 'today' | 'yesterday' | 'last7' | 'last30' | 'last90' | 'yearToDate';

export interface DateRangeWindow {
  start: Date;
  end: Date;
}

export type DateRangeSelection = { preset: DateRangePreset } | ({ preset: 'custom' } & DateRangeWindow);

export interface DateRangeChange extends DateRangeWindow {
  selection: DateRangeSelection;
}

export const DATE_RANGE_PRESETS: readonly { preset: DateRangePreset; labelKey: string }[] = [
  { preset: 'today', labelKey: 'dateRange.today' },
  { preset: 'yesterday', labelKey: 'dateRange.yesterday' },
  { preset: 'last7', labelKey: 'dateRange.last7days' },
  { preset: 'last30', labelKey: 'dateRange.last30days' },
  { preset: 'last90', labelKey: 'dateRange.last90days' },
  { preset: 'yearToDate', labelKey: 'dateRange.yearToDate' },
];

const ALL_DATE_RANGE_PRESETS: readonly string[] = DATE_RANGE_PRESETS.map((option) => option.preset);

/** Local calendar days, so the range follows the user's clock rather than the UTC date. */
export function resolveDateRangePreset(preset: DateRangePreset, now: Date = new Date()): DateRangeWindow {
  const daysBack = (days: number) => new Date(now.getFullYear(), now.getMonth(), now.getDate() - days);
  const today = daysBack(0);
  switch (preset) {
    case 'today':
      return { start: today, end: today };
    case 'yesterday':
      return { start: daysBack(1), end: daysBack(1) };
    case 'last7':
      return { start: daysBack(7), end: today };
    case 'last30':
      return { start: daysBack(30), end: today };
    case 'last90':
      return { start: daysBack(90), end: today };
    case 'yearToDate':
      return { start: new Date(now.getFullYear(), 0, 1), end: today };
  }
}

export function isDateRangePreset(value: string): value is DateRangePreset {
  return ALL_DATE_RANGE_PRESETS.includes(value);
}
